import { enhanceCodec, Bytes } from 'scale-ts';

const textEncoder = new TextEncoder();
const textDecoder = new TextDecoder();
const fixedStr = (nBytes) => enhanceCodec(
  Bytes(nBytes),
  (str) => textEncoder.encode(str),
  (bytes) => textDecoder.decode(bytes)
);

export { fixedStr };
//# sourceMappingURL=fixed-str.mjs.map
